import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import ErrorIcon from '@material-ui/icons/Error';
import { useTranslation } from 'react-i18next';

export default function WorkshopTimeRow(props) {
  const { labelId, row, classes } = props;
  const { t } = useTranslation();

  function handleClick(selectedRow) {
    props.handleClick(selectedRow);
  }
  return (
    <TableRow
      className={classes.row}
      hover
      data-testid="row-button"
      onClick={() => handleClick(row)}
      role="checkbox"
      tabIndex={-1}
    >
      <TableCell
        component="th"
        id={labelId}
        className={classes.tableCell}
        scope="row"
      >
        {row.ticketNumber}
      </TableCell>
      <TableCell align="left" className={classes.tableCell}>
        {row.wagonNumber}
      </TableCell>
      <TableCell align="center" className={classes.tableCell}>
        {row.nextRevisionDate}
      </TableCell>
      <TableCell align="center" className={classes.tableCell}>
        {row.wsStartDate}
      </TableCell>
      <TableCell align="center" className={classes.tableCell}>
        {row.wsEndDate}
      </TableCell>
      <TableCell align="center" className={classes.tableCell}>
        {row.wsDuration != null ? row.wsDuration : '-'}
      </TableCell>
      <TableCell align="center" className={classes.tableCell}>
        {row.wsContractualDuration != null ? row.wsContractualDuration : '-'}
      </TableCell>
      <TableCell align="center" className={classes.tableCell}>
        {row.overdueTime != null ? row.overdueTime : '-'}
      </TableCell>
      <TableCell align="left" className={classes.tableCell}>
        {t(row.ticketStatus)}
      </TableCell>
      <TableCell align="center" className={classes.tableCell}>
        {row.creditNotes != null ? row.creditNotes : '-'}
      </TableCell>
      <TableCell align="center" className={classes.tableCell}>
        {row.contractNumber}
      </TableCell>
      <TableCell align="center" className={classes.tableCell}>
        {row.keeper}
      </TableCell>
      <TableCell align="center" className={classes.tableCell}>
        {row.hasAlert && (
          <ErrorIcon data-testid="alert" className={classes.errorIcon} />
        )}
      </TableCell>
    </TableRow>
  );
}
